import { render } from "./TheCertificate.vue?vue&type=template&id=e07af7e8&scoped=true"
import script from "./TheCertificate.vue?vue&type=script&lang=js"
export * from "./TheCertificate.vue?vue&type=script&lang=js"

import "./TheCertificate.vue?vue&type=style&index=0&id=e07af7e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07af7e8"]])

export default __exports__